// 2024 Shillelagh: while the spell lasts, melee attacks with the Club or Quarterstaff you hold can use your
// spellcasting ability instead of Strength, the damage die becomes a d8 (d10 at character level 5, d12 at
// 11, 2d6 at 17), and the damage can be Force (applied as Force here).
export const SHILLELAGH_EFFECT_ID = 'spell:shillelagh';
export const SHILLELAGH_WEAPON_KEYS = Object.freeze(['club', 'quarterstaff']);

const weaponKey = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
export const isShillelaghWeapon = (weapon) => [weapon?.index, weapon?.type, weapon?.name].some((value) => SHILLELAGH_WEAPON_KEYS.includes(weaponKey(value)));
export const hasShillelagh = (activeEffects, combatantId) => (Array.isArray(activeEffects) ? activeEffects : [])
  .some((effect) => effect?.definitionId === SHILLELAGH_EFFECT_ID && String(effect.targetCombatantId) === String(combatantId));
export const shillelaghDie = (characterLevel) => (characterLevel >= 17 ? '2d6' : characterLevel >= 11 ? '1d12' : characterLevel >= 5 ? '1d10' : '1d8');

/** The weapon's damage with Shillelagh's die and Force type, e.g. "1d6 bludgeoning" -> "1d8 force". */
export const shillelaghDamage = (damage, characterLevel) => {
  const text = String(damage || '');
  const withDie = /\d+d\d+/i.test(text) ? text.replace(/\d+d\d+/i, shillelaghDie(characterLevel)) : `${shillelaghDie(characterLevel)} ${text}`.trim();
  return /\b(bludgeoning|piercing|slashing)\b/i.test(withDie) ? withDie.replace(/\b(bludgeoning|piercing|slashing)\b/i, 'force') : `${withDie} force`;
};
